module.exports = __webpack_public_path__ + "static/media/googlecloudlogo.997901b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/googlecloudlogo.png
// module id = 835
// module chunks = 0